import axios from 'axios';
export const TIMEOUT_AXIOS_REQUEST: number = 100200;

const api = axios.create({
    headers: {
    'x-api-key': import.meta.env.VITE_FINANCING_API_KEY
  },
  baseURL: import.meta.env.VITE_FINANCING_API_BASE_URL,
  timeout: TIMEOUT_AXIOS_REQUEST,
});

export default api;
